import { render } from "./SearchHighlightText.vue?vue&type=template&id=d1a50b08"
import script from "./SearchHighlightText.vue?vue&type=script&lang=js"
export * from "./SearchHighlightText.vue?vue&type=script&lang=js"

import "./SearchHighlightText.vue?vue&type=style&index=0&id=d1a50b08&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__